import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@mui/material';
import { formatAmountForDisplayWithPreferences } from 'utils/index';
import { usePreferences } from 'hooks/usePreferences';
import { formatDateWithPreferences } from 'utils/dateFormatUtils';

const CustomerReport = ({ data }) => {
  const { preferences } = usePreferences();

  return (
  <Box>
    <Typography variant="h5" gutterBottom>Customer Report</Typography>
    <Typography variant="subtitle1" color="textSecondary" gutterBottom>
      Date range: {formatDateWithPreferences(data.dateFrom, preferences)} to {formatDateWithPreferences(data.dateTo, preferences)}
    </Typography>
    {data.location && (
      <Typography variant="subtitle2" color="textSecondary" gutterBottom>
        Location: {data.location}
      </Typography>
    )}
    {data.generatedAt && (
      <Typography variant="caption" color="textSecondary" gutterBottom display="block">
        Generated: {formatDateWithPreferences(data.generatedAt, preferences)}
      </Typography>
    )}
    
    <Grid container spacing={3} sx={{ mb: 4 }}>
      <Grid item xs={12} sm={4}>
        <Card>
          <CardContent>
            <Typography color="textSecondary" gutterBottom>New Customers</Typography>
            <Typography variant="h5">{data.summary.newCustomersCount}</Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Card>
          <CardContent>
            <Typography color="textSecondary" gutterBottom>Active Customers</Typography>
            <Typography variant="h5">{data.summary.activeCustomersCount}</Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Card>
          <CardContent>
            <Typography color="textSecondary" gutterBottom>Total Revenue</Typography>
            <Typography variant="h5">{formatAmountForDisplayWithPreferences(data.summary.totalRevenue, preferences)}</Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>

    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <Typography variant="h6" gutterBottom>New Customers</Typography>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Date Added</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.newCustomers.map((customer) => (
                <TableRow key={customer.id}>
                  <TableCell>{customer.firstName} {customer.lastName}</TableCell>
                  <TableCell>{customer.email}</TableCell>
                  <TableCell>{customer.createdAt}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      
      <Grid item xs={12} md={6}>
        <Typography variant="h6" gutterBottom>Top Customers</Typography>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell align="right">Spent</TableCell>
                <TableCell align="right">Invoices</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.topCustomers.map((customer) => (
                <TableRow key={customer.id}>
                  <TableCell>{customer.first_name} {customer.last_name}</TableCell>
                  <TableCell align="right">{formatAmountForDisplayWithPreferences(customer.total_spent, preferences)}</TableCell>
                  <TableCell align="right">{customer.invoice_count}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  </Box>
  );
};

export default CustomerReport;
